import { render, staticRenderFns } from "./watchers-dropdown.vue?vue&type=template&id=577d4762"
import script from "./watchers-dropdown.vue?vue&type=script&lang=js"
export * from "./watchers-dropdown.vue?vue&type=script&lang=js"
import style0 from "./watchers-dropdown.vue?vue&type=style&index=0&id=577d4762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports